<template>
    <page-view title="代码生成">
        <a-card>
            <a-form :form="form">
                    <a-form-item label="数据库表名" v-bind="formItemLayout">
                        <a-input placeholder="数据库表名如asm_attendance（必须存在）"
                                 v-decorator="['tableName',{ rules: [{ required: true, message: '请输入数据库表名' }]}]"></a-input>
                    </a-form-item>
                    <a-form-item label="POJO类名" v-bind="formItemLayout">
                        <a-input placeholder="后端类文件命名如请休假表名asm_attendance那填写attendance"
                                 v-decorator="['className',{ rules: [{ required: true, message: '请输入POJO类名' }]}]"></a-input>
                    </a-form-item>
                    <a-form-item label="模块名称" v-bind="formItemLayout">
                        <a-input placeholder="请输入模块名称如书籍管理的输入书籍即可"
                                 v-decorator="['title',{ rules: [{ required: true, message: '请输入模块名称' }]}]"></a-input>
                    </a-form-item>
                    <a-form-item label="字段注解" v-bind="formItemLayout">
                        <a-input placeholder="后端注解例子：userid=编号、name=名称"
                                 v-decorator="['itemLog',{ rules: [{ required: true, message: '请输入模块名称' }]}]"></a-input>
                    </a-form-item>
                    <a-form-item label="后端模块路径" v-bind="formItemLayout">
                        <a-input placeholder="后端模块路径"
                                 v-decorator="['javaPath',{initialValue:'E:\\gdjspg\\server\\src\\main\\java\\com\\fxoa\\epp\\', rules: [{ required: true, message: '后端模块路径' }]}]"></a-input>
                    </a-form-item>
                    <a-form-item label="前端模块路径" v-bind="formItemLayout">
                        <a-input placeholder="前端模块路径"
                                 v-decorator="['jspPath',{initialValue:'E:\\gdjspg\\web\\src\\epp\\'}]"></a-input>
                    </a-form-item>
                    <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
                        <a-button type="primary" @click="submit" :loading="loading">生成代码</a-button>
                    </a-form-item>
            </a-form>
        </a-card>
    </page-view>
</template>

<script>
  import { PageView } from '@/layouts'
  import qs from 'qs'
  export default {
    name: 'add',
    inject:['reload'],
    components: {
      PageView
    },
    data () {
      return {
        form: this.$form.createForm(this),
        formItemLayout: {
          labelCol: {
            lg: { span: 7 }, sm: { span: 7 }
          },
          wrapperCol: {
            lg: { span: 10 }, sm: { span: 17 }
          }
        },
        loading: false
      }
    },
    methods: {
      submit () {
        this.form.validateFields((err, values) => {
          if (err) {
            return
          }
          const that = this
          let data = that.form.getFieldsValue()
          this.$http.post('/api/1/dev/codegen/create', qs.stringify(data)).then(function (response) {
            if (response.code !== 200) {
              return
            }
            that.$message.success('操作成功')
            that.reload()
          })
        })
      }
    }
  }
</script>

<style scoped>

</style>
